<template>
  <div class="game-start layers">
    <div class="scroller" ref="scroller">
      <div class="long-content" ref="content">

        <div class="menu-padder"></div>
        <div class="radiance-title">
          {{ T('/game-start@how-to-unlock') }}

        </div>

        <!-- <div class="radiance-desc">
          <div class="radiance-desc-content" v-if="SC.U === CHI">
            Clé de Peau Beauté 誠邀大家一起籌集<span class="numbers">5,000</span>個閃耀力量，並於活動後向Make-A-Wish捐出共 <span class="numbers">HK$150,000</span>，為願望童帶來更多關愛和希望。
          </div>
          <div class="radiance-desc-content" v-if="SC.U === ENG">
            From today till 4th April, Clé de Peau Beauté cordially invites you to raise <span class="numbers">5,000</span> radiance, and will donate <span class="numbers">HK$150,000</span> to Make-A-Wish Hong Kong, to extend its radiance and grant more life-changing wishes to children in need.
          </div>
        </div> -->

        <!-- <div class="instructions" :class="{ 'ENG': SC.U === ENG, 'CHI': SC.U === CHI }">
          <div class="instructions-content">
            <img class="instruction-bg" src="./img/frame.svg" alt="">
            <div class="instruction-text">
              <div class="instruction-title">
                {{ T('/game-start@ways-to-get') }}
              </div>
              <Instruction class="instruction-svg" />
            </div>
          </div>
        </div> -->

        <div class="box-row">
          <img class="step-box" src="./Steps/BoxENG.svg" v-if="SC.U === ENG" />
          <img class="step-box" src="./Steps/BoxCHI.svg" v-if="SC.U === CHI" />
        </div>

        <CTA :text="T('/game-start@unlock-radiance-cta')" @action="$router.push('/choose-photo'); saveStep1()" />

        <!-- <div class="unlock">
          <div class="unlock-content" @click="$router.push('/choose-photo')">
            <img class="unlock-frame" src="./img/unlock.svg" />
            <div class="unlock-text">
              {{ T('/game-start@unlock-radiance-cta') }}
            </div>
          </div>
        </div> -->


        <div class="toc-row">
          <div class="toc" @click="openTOC">
            <span v-if="SC.U === CHI">條款及細則</span>
            <span v-if="SC.U === ENG">Terms & Conditions</span>
          </div>
        </div>


        <div class="bottom-padding"></div>

        <!-- <div class="taller"></div>
        <div class="taller"></div> -->
      </div>
    </div>

    <FloatMenu class="float-menu" @diamond="() => { fsMenu = !fsMenu }" />
    <FullMenu class="full-menu" v-show="fsMenu" @close="() => { fsMenu = false }" @lang="() => { Text.toggle() }" />
    <TOCPopup class="full-popup" v-show="tocPop" @close="() => { tocPop = false }" />
  </div>
</template>

<script>
import FloatMenu from '@/components/DOM/FloatMenu/FloatMenu.vue'
import FullMenu from '@/components/DOM/FullMenu/FullMenu.vue'
import CTA from '@/components/DOM/CTA/CTA.vue'
import * as Text from '@/components/DOM/Text/Text.js'
import * as Server from '@/components/DOM/Server/Server.js'
import TOCPopup from './TOCPopUp.vue'
import * as ScrollMonitor from '@/components/Parts/ScrollMonitor/ScrollMonitor.js'

import Instruction from './Instruction.vue'

export default {
  components: {
    TOCPopup,
    FloatMenu,
    FullMenu,
    CTA,
    Instruction
  },
  data () {
    return {
      tocPop: false,
      Text,
      SC: Text.state,
      T: Text.T,
      ENG: Text.ENG,
      CHI: Text.CHI,

      fsMenu: false,
      clean () {}
    }
  },
  mounted () {
    ScrollMonitor.setPercentage(0)
    this.setupScroll()
    window.addEventListener('resize', () => {
      this.setupScroll()
    })
  },
  methods: {
    saveStep1 () {
      Server.recordStep({ step: 1 })
    },
    openTOC () {
      if (window.innerWidth < 767) {
        this.$router.push('/toc')
      } else {
        this.tocPop = true
      }
    },
    setupScroll () {
      this.clean()
      var scroller = this.$refs['scroller']
      if (!scroller) {
        return
      }
      var content = this.$refs['content']
      var scrollerHeight = scroller.getBoundingClientRect().height
      var ccontentHeight = content.getBoundingClientRect().height
      var onScroll = () => {
        this.scrollPos = scroller.scrollTop

        ScrollMonitor.state.percentage = 0.25 * (scroller.scrollTop) / (ccontentHeight - scrollerHeight)
        // console.log(ScrollMonitor.state.percentage)
      }
      scroller.addEventListener('scroll', onScroll, false)

      this.clean = () => {
        if (scroller) {
          scroller.removeEventListener('scroll', onScroll)
        }
      }
    }
  }
}
</script>

<style scoped>
.game-start{
  color: white;
}
.full-menu{
  position: absolute;
  top: 0px;
  left: 0px;
}
.full-popup{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}
.float-menu{
  position: absolute;
  top: 0px;
  left: 0px;
}
.layers{
  width: 100%;
  height: 100%;
  position: relative;
  overflow:hidden;
}

.scroller{
  position: absolute;
  top: 0px;
  left: 0px;

  width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  color: white;
}
.menu-padder{
  height: 90px;
}
.taller{
  height: 75vh;
}

.radiance-title{
  margin-top: 30px;
  /* How to unlock your r: */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 26px;
  color: #CEBC9E;
  letter-spacing: 0.93px;
  text-align: center;
  line-height: 32px;
}
.radiance-desc{
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  /* Lorem ipsum dolor si: */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 1px;
  line-height: 20px;
}
.radiance-desc-content{
  width: 100%;
  max-width: 319px;
}
.radiance-desc-content .numbers{
  /* Clé de Peau Beauté 誠: */
  font-family: PlayfairDisplay-Regular, CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 16px;
  color: #CEBC9E;
  letter-spacing: 1px;
  line-height: 24px;
}

.instructions{
  position: relative;
  margin-top: 20px;
  height: 381px;
}
.instruction-bg{
  position: absolute;
  top: 0px;
  left: 0px;
}
.instructions-content{
  width: 311px;
  height: 381px;
  position: absolute;
  top: 0px;
  left: calc(50% - 311px / 2);
}
.instructions-text{
  width: 311px;
  height: 381px;
  position: absolute;
  top: 0px;
  left: calc(50% - 311px / 2);
}
.instruction-title{
  width: 240px;
  text-align: center;
  position: absolute;
  top: 35px;
  left: calc(50% - 240px / 2);
  /* Ways to collect Radi: */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 18px;
  color: #FFFFFF;
  letter-spacing: 1.29px;
  line-height: 24px;
}

.instruction-svg{
  position: absolute;
  top: 108px;
  left: 19px;
}
.CHI .instruction-svg{
  top: 91.8px;
}

.unlock{
  position: relative;
  margin-top: 0px;
  height: 55px;
}
.unlock-content{
  cursor: pointer;
  width: 305px;
  height: 55px;
  position: absolute;
  top: 0px;
  left: calc(50% - 305px / 2);
}
.unlock-text{
  position: absolute;
  top: 22px;
  left: 0px;
  width: 305px;
  height: 55px;
  text-align: center;
  text-transform: uppercase;

  /* UNLOCK your radiance: */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 2px;
  text-align: center;
  line-height: 22px;
}
.unlock-frame{
  position: absolute;
  top: 0px;
  left: -5px;
}
.bottom-padding{
  height: 50px;
}
.toc-row{
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.toc{
  display: inline-block;
  cursor: pointer;
  margin-top: 5px;
  /* Choose another photo: */
  /* border: 0 solid #CEBC9E; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 15px;
  color: #CEBC9E;
  letter-spacing: 1px;
  text-align: center;
  line-height: 20px;

  /* Line 3: */
  border-bottom: 1px solid #CEBC9E;
}

.box-row{
  margin-top: 20px;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}
.step-box{
  min-height: 355px;
}

@media screen and (max-width: 321px) {
  .box-row{
    margin-top: 0px;
  }
  .step-box{
    transform: scale(0.95);
  }
  .long-content{
    transform: scale(0.9) translateY(-5%);
  }
  .bottom-padding{
    height: 0px;
  }
}

@media screen and (min-width: 374px) {
  .box-row{
    margin-bottom: 20px;
  }
}
@media screen and (min-width: 414px) {
  .box-row{
    margin-bottom: 20px;
  }
}

@media screen and (min-width: 767.77px) {
  .step-box{
    height: 457px;
  }
  .box-row{
    margin-top: 36px;
    margin-bottom: 0px;
  }
/* @media screen and (min-width: 1439px) { */
  .radiance-title{
    font-size: 28px;
    margin-top: 40px;
  }
  img.instruction-bg {
    width: 400px;
    height: 455px;
    left: calc(50% - 400px / 2);
  }
  .instruction-title{
    font-size: 20px;
    margin-top: 20px;
  }
  .instruction-svg{
    transform: scale(1.2);
    height: 360.4px;
  }
  .unlock{
    margin-top: 20px;
  }
  .unlock-frame{
    width: 400px;
    height: 82px;
    left: calc(50% - 400px / 2);
  }
  .unlock-text{
    top: 30px;
  }
  .toc-row{
    margin-top: 25px;
  }
  .toc{
    font-size: 14px;
  }
  .scroller .cta-row{
    margin-top: 55px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Pages/GameStart/GameStart.vue